export const VITE_BASE_URL_LEGACY = import.meta.env.VITE_BASE_URL_LEGACY;
export const VITE_BASE_URL_NAMEK = import.meta.env.VITE_BASE_URL_NAMEK;
export const VITE_BASE_URL_ORION = import.meta.env.VITE_BASE_URL_ORION;
export const VITE_TENANT_ORION = import.meta.env.VITE_TENANT_ORION;
export const VITE_ORION_TEMP_FILES_SETTLEMENT_PROJECTNAME = import.meta.env
  .VITE_ORION_TEMP_FILES_SETTLEMENT_PROJECTNAME;

export const VITE_ENCRYPT_KEY = import.meta.env.VITE_ENCRYPT_KEY;
export const COMPANY_ID = import.meta.env.VITE_COMPANY_ID;
